<template>
    <Navbar sidebarLink="Bookmarks">
    

    <Recommendations category="Bookmarks"/>
      
    </Navbar>
    
    </template>
    
    <script>
    
    import Recommendations from '@/components/Recommendations.vue'
    import Navbar from '@/components/Navbar.vue'

    
    export default {
      name: 'BooksView',
      components: {
        Navbar,Recommendations
      }
    }
    </script>
    